import {Children, useEffect, useState, cloneElement} from "react";

function MatchMedia({query, children}) {
    const [matches, setMatches] = useState(window.matchMedia(query).matches)

    useEffect(()=>{
        let media = window.matchMedia(query);

        if(media.matches !== matches){
            setMatches(media.matches);
        }

        let listener = () => setMatches(media.matches);
        media.addEventListener("change", listener);

        return () => media.removeEventListener("change", listener);

    }, [query]);


    return <div className={'field'}>
        {Children.map(children, (child) => {
            return cloneElement(child, {matches});
        })}
    </div>;
}

MatchMedia.Success = function(props){
    if(props.matches) return props.children;
    return null;
};

MatchMedia.Failed = function(props){
    if(!props.matches) return props.children;
    return null;
};

export {MatchMedia};